import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/auth";
import { doc, getDoc } from "@firebase/firestore";
import { db } from '../../services/firebaseConnection';

const Comment = ({ comment }) => {
    const { user } = useContext(AuthContext);
    const [commentUser, setCommentUser] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            if (comment.userId) {
                const userRef = doc(db, "users", comment.userId);
                const userSnapshot = await getDoc(userRef);
                if (userSnapshot.exists()) {
                    const userData = userSnapshot.data();
                    setCommentUser(userData);
                }
            }
        };

        fetchUserData();
    }, [comment.userId]);

    const username = commentUser ? commentUser.username : "Usuário Desconhecido";
    const avatarUrl = commentUser ? commentUser.avatarUrl : "";
    

    return (
        <div className="comments">
            <div className="post-header">
            {avatarUrl ? (
                <img src={avatarUrl} className="post-avatar" alt="Avatar do usuário" />
            ) : null}
            <span className="post-username">{username}</span>
            <div className="comment-content">
                <p> {comment.comment}</p>
            </div>
        </div>
        </div>
    );
};



export default Comment;
